import { Component, AfterViewInit, OnDestroy, ChangeDetectorRef, } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToggleConfirmarComponent } from '../../../toggleConfirmar/toggleconfirmar.component';
import { PreguntasObligatoriasComponent } from '../../preguntasobligatorias/preguntasobligatorias.component';
import { TdLoadingService, TdMediaService, TdDialogService, } from '@covalent/core';
import { MdSelect, MdDialog } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs';

import { PatronesService, LoginService, } from '../../../../../services/';

import { Patron } from '../../../../../models';

@Component({
  selector: 'qs-testdetalle',
  styleUrls: ['./testdetalle.component.scss'],
  templateUrl: './testdetalle.component.html',
  viewProviders: [ PatronesService, ],
})

export class TestDetalleComponent implements AfterViewInit, OnDestroy {
  private _dialogServiceEliminar: ToggleConfirmarComponent;
  private titulo: string;
  private accion: string;
  private patron: any;
  private oldPatron: Patron;
  private agrupacion: any;
  private fecha: string;
  private agrupaciones: any;
  private idValoracion: number;
  private idRespuesta: string;
  private idPatron: any;
  private preguntasExcluyentes: any;
  public title: string;
  public tipoEdad: string;
  public idPaciente: string;
  public mode: string;
  public size: boolean;

  constructor(private _loadingService: TdLoadingService,
    private _dialogServiceConfirmar: TdDialogService,
    public media: TdMediaService,
    private _router: Router,
    private _dialogService: TdDialogService,
    private _route: ActivatedRoute,
    private _patronesService: PatronesService,
    private _loginService: LoginService,
    private _changeDetectorRef: ChangeDetectorRef) {
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this.patron = new Patron();
    this.oldPatron = new Patron();
    if (this._loginService.transient) {
      this.mode = 'edit';
      this.title = 'Editar';
      this.patron = this._loginService.transient;
    } else {
      this.mode = 'add';
      this.title = 'Añadir';
    }
  }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('testdetalle.load');
    this._changeDetectorRef.detectChanges();
    this.idValoracion = this.patron.idRespuesta;
    this.idRespuesta = String(this._loginService.transient.idRespuesta);

    let idPatron: number = this._loginService.transient.idPatron;
    this.titulo = this._loginService.transient.textoPatron;
    const newLocal: string = 'No ha sido posible obtener el test';

    this._patronesService.obtenerPreguntasRespuestasPatronValorado(this.idRespuesta, this.idPaciente)
    .subscribe((res: any) => {
      if (res.error) {
        this._loginService.mostrarMensaje(res.error, 'OK', 6000);
        this._loadingService.resolve('test.load');
        this.close();
      } else if (res.respuesta === '') {
        this._loginService.mostrarMensaje(newLocal, 'OK', 6000);
        this._loadingService.resolve('test.load');
        this.close();
      } else {
        this.patron = res.respuesta;
        this.idPatron = this.patron.patron;
        this.agrupaciones = res.respuesta.agrupaciones;
        this.preguntasExcluyentes = res.respuesta.preguntasExcluyentes;

        if (this.agrupaciones.length > 1) {
          this.size = true;
        } else {
          this.size = false;
        }

        // NECESARIO PARA DAR FORMATO TIPO DATE A LA VARIABLE FECHA PARA QUE
        // SEA RECONOCIDO POR EL DATEPICKER DEL FORMULARIO
        for (let grupo in this.agrupaciones) {
          this.agrupacion = this.agrupaciones[grupo].agrupacion;
          for ( let pregunta in this.agrupacion) {
            if (this.agrupacion[pregunta].respuestas.length > 0) {
              if (this.agrupacion[pregunta].respuestas[0].fecha !== undefined) {
                this.fecha = this.agrupacion[pregunta].respuestas[0].fecha;
                this.agrupacion[pregunta].respuestas[0].fecha = new Date(this.fecha);
              }
            }
          }
        }
        this._loadingService.resolve('testdetalle.load');
      }
    }, (_error: Error) => {
      this._loadingService.resolve('test.load');
      this.close();
    });
    // this._changeDetectorRef.detectChanges();
  }

  delete(): void {
    this._dialogServiceEliminar = new ToggleConfirmarComponent(this._dialogServiceConfirmar);
    let mensaje: any = 'Pulse ACEPTAR para borrar el programa.';
    let titulo: any = 'Borrar Programa';

    this._dialogServiceEliminar.openConfirm(mensaje, titulo).subscribe((resp: any) => {

      if (resp) {
        this._patronesService.BorrarPatronPaciente(this.idPaciente, this.idValoracion.toString())
        .subscribe((res: any) => {
          if (res) {
            this._loginService.patron = res;
            this._loginService.mostrarMensaje('Programa eliminado correctamente.', 'OK', 6000);
            this._router.navigate(['/main/consulta/' + this.idPaciente + '/modanamnesis', { outlets: { modanamnesis: ['test'] } }]);
          } else {
            this._loginService.mostrarMensaje('Error eliminando programa.', 'OK', 6000);
            this._loadingService.resolve();
          }
        }, (_resError: Error) => {
          this._loginService.mostrarMensaje('Error procesando la eliminación', 'OK', 6000);
          this._loadingService.resolve();
        });
      }
    });
  }

  save(_form: NgForm): void {
    let validado: boolean;
    let fecha: Date = new Date();
    // let hora: string = fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds();
    validado = this.verificarPreguntaObligatoria();
    if (!validado) {
      this.openDetail();
    } else {
        this._loadingService.register();
        let params: any = {
          idPatron: this.idPatron,
          idValoracion: this.idValoracion,
          textoPatron: this.titulo,
          numExpediente: this.idPaciente,
          fechaCumplimentacion: fecha,
          dniMedico: this._loginService.profesional.Dni,
          numVisita: this._loginService.consulta.visita,
          tipoEdad: this.tipoEdad,
          itemsPatron: this.agrupaciones,
        };
        let jparams: any = JSON.stringify(params);

        this._patronesService.HCI_OnCloud_InsertarDatosParaPatronCumplimentado(jparams)
        .subscribe((res: any) => {
          if (res) {
            this._loginService.patron = res;
            this._loginService.mostrarMensaje('Test actualizado correctamente.', 'OK', 6000);
            this._router.navigate(['/main/consulta/' + this.idPaciente + '/modanamnesis', { outlets: { modanamnesis: ['test'] } }]);
          } else {
            this._loginService.mostrarMensaje('Error actualizando test.', 'OK', 6000);
            this._loadingService.resolve();
          }
        }, (_resError: Error) => {
          this._loginService.mostrarMensaje('Error procesando la actualización', 'OK', 6000);
          this._loadingService.resolve();
        });
      }
    this._loadingService.resolve();
  }
  openDetail(): void {
    let dialogRef: any = this._dialogService.open( PreguntasObligatoriasComponent, {
      id: '11',
      width: '60%',
      role: 'dialog',
      height: '22%',
    });
  }
  ngOnDestroy(): void {
    this._loginService.transient = '';
  }
  verificarPreguntaObligatoria(): boolean {
    let validado: any = true;
    for (let grupo in this.agrupaciones) {
      let agrupacion: any = this.agrupaciones[grupo].agrupacion;
      for (let pregunta in agrupacion) {
        if (agrupacion[pregunta].obligatoria === 'S') {
          let respuestas: any = agrupacion[pregunta].respuestas;
          let preguntaActualizada: any = false;
          for (let respuesta in respuestas) {
            if (respuestas[respuesta].seleccionada === true) {
              agrupacion[pregunta].contestada = true;
              preguntaActualizada = true;
            }
          }
          if (agrupacion[pregunta].contestada === false && preguntaActualizada === false) {
            validado = false;
          }
          if (agrupacion[pregunta].contestada === true && preguntaActualizada === false) {
            // agrupacion[pregunta].contestada === false;
            agrupacion[pregunta].contestada = false;
            validado = false;
          }
        }
      }
    }
    return validado;
  }
  close(): void {
    this._router.navigate(['/main/consulta/' + this._loginService.consulta.numeroExpediente + '/modanamnesis',
    { outlets: { modanamnesis: ['test'] } }]);  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/modanamnesis/test/testdetalle/testdetalle.component.ts